import { AccountInfo } from "@azure/msal-browser";
import axios, { TypedResponse } from "./HttpClient";
import { GetUserInfo } from "./IdentityAPI";
import { AxiosResponse } from "axios";
import { set, some } from "lodash";

const serviceManagerURL = ServiceManagerUrl;

export function GetCampaign(campaignId) {
    return axios.get(`${serviceManagerURL}api/Campaigns/${campaignId}`);
}

export function StartQuestionnaire(campaign: Campaign) {
    return GetUserInfo().then((res) => {
        return axios
            .post(`${serviceManagerURL}api/questionnaires`, {
                campaignID: campaign.id,
                organizationID: campaign.organizationID,
                questionnaireTypeID: campaign.questionnaireTypeID,
                // @ts-ignore
                subjectID: res.data.sub,
                subjectType: campaign.questionnaireType?.subjectType,
                allowComments: campaign.allowComments,
                allowUploads: campaign.allowUploads,
            })
            .then((response) => {
                return response.data.result;
            });
    });
}

export function StartImpersonateQuestionnaire(campaign: Campaign, subject) {
    return axios
        .post(`${serviceManagerURL}api/questionnaires`, {
            campaignID: campaign.id,
            organizationID: campaign.organizationID,
            questionnaireTypeID: campaign.questionnaireTypeID,
            // @ts-ignore
            subjectID: subject,
            subjectType: campaign.questionnaireType?.subjectType,
            allowComments: campaign.allowComments,
            allowUploads: campaign.allowUploads,
        })
        .then((response) => {
            return response.data.result;
        });
}

export function CreateQuestionnaire(data: CreateQuestionnaireRequest): Promise<string> {
    return axios.post(`${serviceManagerURL}api/questionnaires`, data).then((response) => {
        return response.data.result;
    });
}
export interface CreateQuestionnaireRequest {
    campaignID?: string;
    organizationID: string;
    organizationIdentityID?: string;
    questionnaireTypeID: string;
    subjectID?: string;
    allowComments?: boolean;
    allowUploads?: boolean;
    name: string;
}

export function QuestionnaireActions() {
    return axios.get(`${serviceManagerURL}api/questionnaires/myactions`).then((response) => {
        return response.data.result;
    });
}

export function GetQuestionnaire(id): Promise<IQuestionnaireInstance> {
    return axios.get(`${serviceManagerURL}api/questionnaires/${id}`).then((response) => {
        return response.data;
    });
}

export function GetMyQuestionnaires() {
    return axios.get(`${serviceManagerURL}api/questionnaires/MyQuestionnaires`).then((response) => {
        return response.data.result;
    });
}

export function UploadAttachment(attachment: Attachment) {
    return axios.post(`${serviceManagerURL}api/attachments`, attachment).then((response) => {
        return response.data.result;
    });
}

export function UploadComment(comment) {
    return axios.post(`${serviceManagerURL}api/comments`, comment).then((response) => {
        return response.data.result;
    });
}

export function DeleteAttachment(attachmentId) {
    return axios.delete(`${serviceManagerURL}api/attachments/${attachmentId}`).then((response) => {
        return response.data.result;
    });
}

export function DeleteComment(commentId) {
    return axios.delete(`${serviceManagerURL}api/comments/${commentId}`).then((response) => {
        return response.data.result;
    });
}

export function AnswerQuestion(questionnaire, question, set, option) {
    return axios.post(`${serviceManagerURL}api/answers/option`, option, {
        params: {
            questionnaire,
            question,
            set,
        },
    });
}

export function UnlockQuestionnaire(id): Promise<{}> {
    return axios.put(`${serviceManagerURL}api/questionnaires/${id}/$unlock`).then((response) => {
        return response.data.result;
    });
}

export function AddSet(questionnaireId, questionId) {
    return axios.post(`${serviceManagerURL}api/questionanswersets`, { questionId, questionnaireId }).then((response) => {
        return response.data.result;
    });
}

export function RemoveSet(setId) {
    return axios.delete(`${serviceManagerURL}api/questionanswersets/${setId}`).then((response) => {
        return response.data.result;
    });
}

export function SubmitQuestionnaire(id) {
    return axios.post(`${serviceManagerURL}api/questionnaires/$submit`, { questionnaireID: id }).then((response) => {
        return response.data;
    });
}

export function GetCampaignSubmissions(id) {
    return axios.get(`${serviceManagerURL}api/campaigns/${id}/$submissions`).then((response) => {
        return response.data.result;
    });
}

export function GetEntityType(entityTypeID: string) {
    return axios.get(`${serviceManagerURL}api/entities/GetEntityType`, { params: { entityTypeID } }).then((response: AxiosResponse<TypedResponse<EntityTypeViewModel>>) => {
        return response.data;
    });
}

export function ListEntities(entityTypeID: string) {
    return axios.get(`${serviceManagerURL}api/Entities/ListEntities`, { params: { entityTypeID } }).then((response: AxiosResponse<TypedResponse<QuestionnaireViewModel[]>>) => {
        return response.data;
    });
}

export function GetEntity(entityID: string) {
    return axios.get(`${serviceManagerURL}api/Entities/GetEntity`, { params: { entityID } }).then((response: AxiosResponse<TypedResponse<EntityViewModel>>) => {
        return response.data;
    });
}

export function GetReferenceList(id) {
    return axios.get(`${serviceManagerURL}api/ReferenceData/list/` + id);
}

export function CreateQuestionnaireScope(id: string, data: QuestionnaireScopeAPIModel): Promise<string> {
    return axios.post(`${serviceManagerURL}api/questionnaires/${id}/$scopes`, data).then((response) => {
        return response.data.result;
    });
}

export function DeleteQuestionnaireScope(id: string, scopeGroupID: string): Promise<string> {
    return axios.delete(`${serviceManagerURL}api/questionnaires/${id}/$scopes/${scopeGroupID}`).then((response) => {
        return response.data.result;
    });
}

export function GetQuestionnaireType(id): Promise<QuestionnaireType> {
    return axios.get(`${serviceManagerURL}api/questionnairetypes/${id}`).then((response) => {
        return response.data.result;
    });
}

export function ListScopeSequences(): Promise<TypedResponse<ScopeTypeSequenceAPIModel[]>> {
    return axios.get(`${serviceManagerURL}api/ScopeTypeSequences/list`).then((response: AxiosResponse<TypedResponse<ScopeTypeSequenceAPIModel[]>>) => {
        return response.data;
    });
}

export function GetQuestionnaireScopes(id): Promise<QuestionnaireScopeAPIModel[]> {
    return axios.get(`${serviceManagerURL}api/questionnairetypes/${id}/$questionnaireScopes`).then((response) => {
        return response.data.result;
    });
}

export function CreateQuestionnaireAccessPolicy(data) {
    return axios.post(`${serviceManagerURL}api/accesspolicies/questionnaire/$create`, data).then((response) => {
        return response.data.result;
    });
}

export function UpdateQuestionnaireAccessPolicy(data) {
    return axios.put(`${serviceManagerURL}api/accesspolicies/questionnaire/$update`, data).then((response) => {
        return response.data.result;
    });
}

export function GetIdentityOrganization(id) {
    return axios.get(`${serviceManagerURL}api/organizations/$identity/` + id).then((response) => {
        response.data.result.identityID = response.data.result.id;
        response.data.result.id = undefined;
        return response.data.result;
    });
}

export function GetServiceManagerOrganizations() {
    return axios.get(`${serviceManagerURL}api/organizations`).then((response) => {
        return response.data.result;
    });
}

export function GetServiceManagerOrganization(id) {
    return axios.get(`${serviceManagerURL}api/organizations/${id}`).then((response) => {
        return response.data.result;
    });
}

export const validate = (validation, value, question, data) => {
    if (value === null) return true;
    let valid = true;

    if (validation.length && validation.length != "0") {
        if (value?.length != parseInt(validation.length)) {
            valid = valid && false;
        }
    }

    if (validation.range && validation.range != "-") {
        let range = validation.range.split("-");
        if (range[0]) {
            if (+value < parseInt(range[0])) {
                valid = valid && false;
            }
        }
        if (range[1]) {
            if (+value > parseInt(range[1])) {
                valid = valid && false;
            }
        }
    }

    if (validation.regularExpression && validation.regularExpression != "") {
        let regex = new RegExp(validation.regularExpression);
        if (!regex.test(value)) {
            valid = valid && false;
        }
    }

    if (validation.evaluate) {
        try {
            let fn = new Function("value", "question", "data", validation.evaluate);
            valid = valid && fn(value, question, data);
        } catch {
            valid = valid && false;
        }
    }

    return valid;
};

export function getSubmissionData(questionnaire: Questionnaire) {
    const output = {};
    try {
        questionnaire.questions.forEach((question) => {
            let preferObject = question.key.endsWith(":object");
            let key = question.key.replace(":object", "");
            let atomic = some(question.options, (o) => o.type === 0) && (!question.options?.every((o) => o.type === 0) || question.options?.length == 1);
            let list = (question.options || []).length > 1 && !atomic && question.multipleOptions;

            if (question.allowSets) {
                let setData = question.sets?.map((s) => {
                    let setOutput = {};
                    s.options?.forEach((option) => {
                        let value = option.type == 0 && !atomic ? option.text : option.value; //
                        set(setOutput, option.key, value);
                    });
                    return setOutput;
                });

                set(output, key, setData);
            } else {
                if (list) {
                    let value = question.answers
                        ?.filter((a) => a.value == "true")
                        .map((answer) => {
                            return answer.option.text; //
                        });
                    set(output, key, value);
                } else {
                    question.answers?.forEach((answer) => {
                        let outputKey = (key + "." + answer.option.key).replace(/\.$/g, "");

                        let value = answer.option.type == 0 && !atomic ? answer.option.text : answer.value; //
                        set(output, outputKey, value);
                    });
                }
            }
        });
    } catch (e) {
        console.log(e);
    }

    return output;
}

export function IsRenderable(mimeType) {
    const renderableMimeTypes = ["application/pdf", "image/jpeg", "image/png", "image/gif", "text/html", "audio/mpeg", "video/mp4"];
    return renderableMimeTypes.includes(mimeType);
}

export interface EntityTypeViewModel {
    id: string;
    name: string;
    organizationID: string;
    questionnaireTypes: QuestionnaireTypeViewModel[];
}

export interface EntityViewModel {
    id: string;
    name: string;
    organizationID: string;
    questionnaire: QuestionnaireViewModel;
    data: QuestionnaireViewModel[];
}

export interface QuestionnaireViewModel {
    id: string;
    timestamp: string;
    name: string;
    description: string;
    questionnaireTypeID: string;
    questionnaireType: QuestionnaireTypeViewModel;
    campaignID: string;
    organizationID: string;
    organization: ServiceManagerOrganization;
    subjectID: string;
    subjectType: SubjectType;
    allowComments: boolean;
    allowUploads: boolean;
    locked: boolean;
    protected: boolean;
    lastSubmissionDate: string;
    questionnaireScopes: QuestionnaireScopeAPIModel[];
}

export class ServiceManagerOrganization {
    id: string;
    identityID?: string;
    identityOrganization?: {
        logoURI: string;
    };
    name: string;
    questionnaires?: Array<any>;
}

export enum SubjectType {
    Organization = 0,
    User = 1,
    Template = 2,
    None = 3,
    EntityType = 4,
    Entity = 5,
}

export interface QuestionnaireTypeViewModel {
    id: string;
    name: string;
    subjectID: string;
    localization: string;
    protected: boolean;
    useCombinedGroupLayout: boolean;
    useGridLayout: boolean;
    allowAnswerCopying: boolean;
    layoutOptions: QuestionnaireTypeLayoutOptions;
    data: QuestionnaireTypeData;
    subjectType: SubjectType;
    organizationID: string;
}

export interface QuestionnaireTypeLayoutOptions {
    stickyDescription: boolean;
    collapseDescription: boolean;
    disableProgress: boolean;
    disableSummary: boolean;
}

export interface QuestionnaireTypeData {
    scoreSettings?: ScoreSettings;
    guidanceSettings?: GuidanceSettings;
}

export interface GuidanceSettings {
    message: string;
}

export interface ScoreSettings {
    scoreLevels: ScoreLevel[];
}

export interface ScoreLevel {
    level: number;
    name: string;
    score: number;
    description: string;
    color: string;
}

export interface GetUserQuestionnaireResponse {
    questionnaires: Questionnaire[];
    campaigns: Campaign[];
}

export class CampaignStatistics {
    submitted: number;
    questionsAnswered: number;
    required: number;
    requiredAnswered: number;
    maxScore: number;
    score: number;
    totalQuestionnaires: number;
}

export class Campaign {
    id: string;
    name: string;
    organizationID?: string;
    key: string;
    // organization?: Organization;
    questionnaireTypeID: string;
    questionnaireType?: QuestionnaireType;
    delegated: boolean;
    allowComments: boolean;
    allowUploads: boolean;
    accessType: number;
    description: string;
    data: CampaignData;
    questionnaires?: Array<Questionnaire>;
    startDate: string | null;
    endDate: string | null;
    flagDate: string | null;
    statistics?: CampaignStatistics;
    campaignFrequency: number;
    accessPolicies: any[];

    constructor(organizationId?: string) {
        this.organizationID = organizationId;
        this.data = new CampaignData();
        this.accessType = 3;
        this.name = "";
        this.description = "";
        this.key = "";
        this.delegated = false;
        this.questionnaires = [];
        this.accessPolicies = [];
    }
}

export class CampaignData {
    constructor() {
        this.icon = "comments-question-check";
        this.groups = [];
        this.allowStaffAsSubjects = false;
        this.allowStudentsAsSubjects = false;
        this.allowParentsAsSubjects = false;
        this.allowGuestsAsSubjects = false;
        this.questionnaireReviews = [];
    }

    groups: string[];
    questionnaireReviews: QuestionnaireReviewConfig[];
    allowStaffAsSubjects?: boolean;
    allowStudentsAsSubjects?: boolean;
    allowParentsAsSubjects?: boolean;
    allowGuestsAsSubjects?: boolean;
    icon: string;
}

export interface QuestionnaireReviewConfig {
    name: string;
    reviewGroupType: string;
    visibleToSubject: boolean;
    visibleToAll: boolean;
}

export interface IQuestionnaireInstance {
    questionnaire: Questionnaire;
    groups: Group[];
    groupStatistics: GroupStatistics[];
    totalStatistics: TotalStatistics;
}

export interface GroupStatistics {
    group: string;
    groupID: string;
    weight: number;
    answered: number;
    required: number;
    requiredAnswered: number;
    max: number;
    score: number;
    maxScore: number;

    weightedScore: number;
    weightedMaxScore: number;

    percentage: number;
}

export interface TotalStatistics {
    answered: number;
    required: number;
    requiredAnswered: number;
    max: number;
    score: number;
    maxScore: number;

    weightedScore: number;
    weightedMaxScore: number;

    percentage: number;
}

export interface Comment {
    id: string;
    text: string;
    userID: string;
    username: string;
    timestamp: string;
    questionID: string;
    questionnaireID: string;
}

export class Questionnaire {
    id: string;
    timestamp: string;
    name: string;
    description: string;
    questionnaireTypeID: string;
    questionnaireType: QuestionnaireType;
    campaignID: string;
    campaign: Campaign;
    organizationID: string;
    organization: ServiceManagerOrganization;
    subjectID: string;
    subjectType: SubjectType;
    allowComments: boolean;
    allowUploads: boolean;
    locked: boolean;
    lastSubmissionDate: string;
    answers: Array<Answer>;
    comments: Array<Comment>;
    accessPolicies: Array<QuestionnaireAccessPolicy>;
    questions: Array<Question>;

    flagged: boolean;
    protected: boolean;

    questionnaireReviews: QuestionnaireReview[];
    reviewedBy: QuestionnaireReview[];
    reviews: QuestionnaireReview[];

    score: number;
    maxScore: number;
    totalQuestions: number;
    answeredQuestions: number;
    requiredQuestions: number;
    requiredAnsweredQuestions: number;
    weightedScore: number;
    weightedMaxScore: number;
    percentage: number;

    questionnaireScopes: QuestionnaireScopeAPIModel[];
}
export interface ScopeTypeAPIModel {
    id: string;
    name: string;
    organizationID: string;
    scopeGroups: ScopeGroupAPIModel[];
    scopeTypeSequences: ScopeTypeSequenceAPIModel[];
}

export interface ScopeGroupAPIModel {
    id: string;
    scopeTypeID: string;
    name: string;
}

export interface ScopeTypeSequenceAPIModel {
    id: string;
    name: string;
    scopeTypeID: string;
    scopeType: ScopeTypeAPIModel;
}

export interface QuestionnaireScopeAPIModel {
    id: string;
    questionnaireID: string;
    scopeGroupID: string;
    scopeGroup: ScopeGroupAPIModel;
    scopeTypeSequenceID: string;
    scopeTypeSequence: ScopeTypeSequenceAPIModel;
    sequenceNumber: number;
    formattedSequenceNumber: string;
}

export interface QuestionnaireAccessPolicy {
    rule: string;
    questionnaireID: string;
    accessType: number;
    isUserAnswerable: boolean;
    isUserRule: boolean;
}

export interface GetUserQuestionnaireResponse {
    questionnaires: Questionnaire[];
    campaigns: Campaign[];
}

export interface QuestionnaireReportGroup {
    groupID: string;
    groupName: string;
    sortKey: number;
    questions: QuestionnaireReportQuestion[];
}

export interface QuestionnaireReportQuestion {
    questionID: string;
    questionText: string;
    sortKey: number;
    allowSets: boolean;
    answers: QuestionnaireReportAnswer[];
}

export interface QuestionnaireReportAnswer {
    answerID: string;
    answerValue: string;
    questionnaireID: string;
    setID: string;
    optionID: string;
    optionText: string;
    optionValue: string;
    optionType: number;
    optionSortKey: number;
    optionScore: number;
}

export interface QuestionnaireReview {
    id: string;
    name: string;
    questionnaireID: string;
    questionnaire: Questionnaire;
    reviewedByQuestionnaireID: string;
    reviewedByQuestionnaire: Questionnaire;
    reviewer: string;
    visibleToSubject: boolean;
    visibleToAll: boolean;
}

export interface CreateQuestionnaireReviewRequest {
    questionnaireID: string;
    subjectID: string;
    reviewName: string;
    visibleToAll: boolean;
    visibleToSubject: boolean;
}

export class Question {
    id: string;
    text: string;
    subtext: string;
    weight: number;
    sortKey: number;
    multipleOptions: boolean;
    allowSets: boolean;
    allowUploads: boolean;
    allowComments: boolean;
    groups?: Array<QuestionGroup>;
    selected?: boolean;
    required?: boolean;
    conditions: Array<Condition>;
    options?: Array<Option>;
    organizationID: string;
    key: string;
    answers?: Answer[];
    sets?: any[];
    attachments?: Attachment[];
    comments?: any[];
    tags: QuestionTag[];
    dataValidations: QuestionDataValidationAPIModel[];
}

export interface QuestionDataValidationAPIModel {
    id: string;
    questionID: string;
    name: string;
    range: string;
    regularExpression: string;
    length: string;
    evaluate: string;
    optionsAppliedTo: string[];
}
export interface Attachment {
    id: string;
    name: string;
    content: string;
    contentType: string;
    contentURI: string;
    thumbURI: string;
    userID: string;
    username: string;
    timestamp: string;
    questionID: string;
    questionnaireID: string;
}

export class QuestionTag {
    id: string;
    questionID: string;
    tagID: string;
    tag: TagAPIModel;
}

export class Condition {
    id: string;
    questionID: string;
    question: Question;
    reliesOnID: string;
    reliesOn: Question;
    type: number;
    conditionOptions: Array<ConditionOption>;
}

export class ConditionOption {
    id: string;
    optionID: string;
    option?: Option;
}

export interface QuestionGroup {
    id: string;
    questionID: string;
    question: Question;
    groupID: string;
    group: Group;
}

export interface QuestionQueryModel {
    id: string;
    text: string;
    subtext: string;
    key: string;
    multipleOptions: boolean;
    weight: number;
    sortKey: number;
    allowSets: boolean;
    allowComments: boolean;
    allowUploads: boolean;
    required: boolean;
    conditions: Condition[];
    groups: GroupQueryModel[];
    options: Option[];
    organizationID: string;
    tags: TagAPIModel[];
    dataValidations: QuestionDataValidationAPIModel[];
}

export interface GroupQueryModel {
    id: string;
    name: string;
    weight: number;
    sortKey: number;
}

export class Option {
    id: string;
    questionID?: string;
    text: string;
    score: number;
    sortKey: number;
    type: any;
    value?: any;
    key?: string;
    referenceListID?: string;
}

export interface TagAPIModel {
    id: string;
    name: string;
    color: string;
}
export class Group {
    id: string;
    name: string;
    weight: number;
    sortKey: number;
    questions?: Array<Question>;
    questionnaireTypes?: Array<QuestionnaireType>;
    selected: boolean;
    organizationID?: string;
}

export class Answer {
    id: string;
    value: string;
    optionID: string;
    option: Option;
    questionID: string;
    question: Question;
    setID: string;
    set: any;
    questionnaireID: string;
    questionnaire: Questionnaire;
}

export interface QuestionnaireTypeAccessPolicy {
    accessType: number;
    questionnaireTypeID: string;
    rule: string;
    questionnaireAccessType: number;
}

export class QuestionnaireType {
    id: string;
    name: string;
    description: string;
    groups: Array<Group>;
    selected: boolean;
    subjectType: SubjectType;
    accessPolicies: Array<QuestionnaireTypeAccessPolicy>;
    organizationID: string;
    tags: Array<TagAPIModel>;
    protected: boolean;
    useCombinedGroupLayout: boolean;
    useGridLayout: boolean;
    allowAnswerCopying: boolean;
    localization: any;
    layoutOptions?: {
        stickyDescription: boolean;
        collapseDescription: boolean;
        disableProgress: boolean;
        disableSummary: boolean;
    };
    data?: QuestionnaireTypeData;

    scopeSequences: QuestionnaireTypeScopeSequence[];
    scopeTypes: QuestionnaireTypeScopeType[];
}

export interface QuestionnaireTypeScopeSequence {
    questionnaireTypeID: string;
    scopeTypeSequenceID: string;
    scopeTypeSequence: ScopeTypeSequenceAPIModel;
}

export interface QuestionnaireTypeScopeType {
    questionnaireTypeID: string;
    scopeTypeID: string;
    scopeType: ScopeTypeAPIModel;
}

export interface ApplicationAction {
    text: string;
    uRL: string;
    icon: string;
    type: ApplicationActionType;
    data: any;
}

export enum ApplicationActionType {
    ExistingQuestionnaire = 1,
    NewQuestionnaire = 2,
}
